<script setup lang="ts">
import { provide } from "vue";
import DRBtnIcon from "@/components/UI/DRBtnIcon.vue";
import { IN_PANEL_DIALOG } from "@/components/canvas/DrawerMenus/drawerMenuContext";

/**
 * Modale qui accueille le contenu d'un ancien onglet du volet droit (activité,
 * sauvegardes), ouvert depuis le menu fichier. Même présentation que dans le
 * volet : le contenu porte son titre et son aide, la fermeture est en haut à
 * gauche. Le contenu est démonté à la fermeture, après l'animation (il se
 * recharge à chaque ouverture, comme le volet).
 */
defineProps<{
  /** Nom de la modale pour les lecteurs d'écran (l'en-tête visible est celui du contenu). */
  title: string;
}>();

const visible = defineModel<boolean>({ required: true });

provide(IN_PANEL_DIALOG, true);
</script>

<template>
  <el-dialog
    v-model="visible"
    class="canvas-panel-dialog"
    width="min(480px, 92vw)"
    :title="title"
    :show-close="false"
    destroy-on-close
    append-to-body
    align-center
  >
    <div class="panel-dialog-body">
      <DRBtnIcon
        type="button"
        variant="flat-white"
        :size="30"
        phosphor-icon="x"
        :aria-label="$t('close')"
        class="panel-dialog-close position-absolute top-0 start-0 m-2"
        @click="visible = false"
      />
      <slot :close="() => (visible = false)"></slot>
    </div>
  </el-dialog>
</template>

<style lang="scss" scoped>
// Hauteur fixe : la liste défile à l'intérieur, comme dans le volet.
.panel-dialog-body {
  position: relative;
  height: min(640px, 80vh);
}

// Au-dessus du titre du contenu (positionné), comme dans le volet.
.panel-dialog-close {
  z-index: 1;
}
</style>

<!-- Non-scoped : el-dialog est téléporté dans <body> -->
<style lang="scss">
// L'en-tête d'el-dialog est masqué (le contenu a le sien) ; son titre ne sert
// qu'à nommer la modale pour les lecteurs d'écran.
.el-dialog.canvas-panel-dialog {
  padding: 0;
  overflow: hidden;
  border-radius: 12px;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }
}
</style>
